import { Component, OnInit } from '@angular/core';
import { DataTestService } from './../services/data-test.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-data-test',
  templateUrl: './data-test.component.html',
  styleUrls: ['./data-test.component.scss']
})
export class DataTestComponent implements OnInit {

  public TestData:string[];
  constructor(private TestService:DataTestService) { }

  ngOnInit() {
    this.TestService.GetTestData().subscribe(i=>{
      this.TestData = i;
    });
    
    
  }

}
